import type { APIResponse } from '@/shared/types'
import { apiService, API_ENDPOINTS } from '@/shared/services/api'

export interface IntakeLinkAssignment {
  id: string
  alias: string
  lawFirmName: string
  intakeFormUrl: string
  emAssignments: OrganizationManager[]
  dmAssignments: OrganizationManager[]
  cmAssignments: OrganizationManager[]
  bmAssignments: OrganizationManager[]
  amAssignments: OrganizationManager[]
}

export interface OrganizationManager {
  id: string
  name: string
  type: 'EM' | 'DM' | 'CM' | 'BM' | 'AM'
  email?: string
  phone?: string
}

export class IntakeLinkAssignmentService {
  /**
   * Save intake link assignments to backend
   */
  static async saveAssignments(assignments: IntakeLinkAssignment[]): Promise<APIResponse<any>> {
    try {
      const response = await apiService.post<APIResponse<any>>(
        API_ENDPOINTS.hr.intakeLinkAssignments,
        assignments
      )
      return response.data
    } catch (error: any) {
      console.error('Error saving intake link assignments:', error)
      throw new Error(error.response?.data?.message || 'Failed to save assignments')
    }
  }

  /**
   * Get existing intake link assignments from backend
   */
  static async getAssignments(): Promise<IntakeLinkAssignment[]> {
    try {
      const response = await apiService.get<APIResponse<IntakeLinkAssignment[]>>(
        API_ENDPOINTS.hr.intakeLinkAssignments
      )
      return response.data.data || []
    } catch (error: any) {
      console.error('Error fetching intake link assignments:', error)
      throw new Error(error.response?.data?.message || 'Failed to fetch assignments')
    }
  }
}

export default IntakeLinkAssignmentService
